enum Color {
    white = "white",
    black = "black"
}
export default Color;